// import React, { useState, useEffect } from 'react';
// import Promotions from './Components/Promotions';
// import PromotionDeta from './Components/PromotionDeta';
// import './App.css';

// function App() {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [screenData, setScreenData] = useState(null);
//   const [deviceInfo, setDeviceInfo] = useState({ deviceId: '', password: '' });

//   // Check localStorage on initial load
//   useEffect(() => {
//     const savedLoginData = localStorage.getItem('promotionLogin');
//     if (savedLoginData) {
//       try {
//         const { screenData, deviceInfo } = JSON.parse(savedLoginData);
//         setScreenData(screenData);
//         setDeviceInfo(deviceInfo);
//         setIsLoggedIn(true);
//         console.log('🔄 Restored login session from localStorage');
//       } catch (error) {
//         console.error('Failed to restore login session:', error);
//         localStorage.removeItem('promotionLogin');
//       }
//     }
//   }, []);

//   // Handle successful login
//   const handleLoginSuccess = (data, deviceId, password) => {
//     // Save to state
//     setScreenData(data);
//     setDeviceInfo({ deviceId, password });
//     setIsLoggedIn(true);
    
//     // Save to localStorage for persistence
//     const loginData = {
//       screenData: data,
//       deviceInfo: { deviceId, password }
//     };
//     localStorage.setItem('promotionLogin', JSON.stringify(loginData));
//     console.log('💾 Login session saved to localStorage');
//   };

//   // Handle logout/back to login
//   const handleLogout = () => {
//     // Clear state
//     setIsLoggedIn(false);
//     setScreenData(null);
//     setDeviceInfo({ deviceId: '', password: '' });
    
//     // Clear localStorage
//     localStorage.removeItem('promotionLogin');
//     console.log('🗑️ Login session cleared from localStorage');
//   };

//   return (
//     <div className="App">
//       {!isLoggedIn ? (
//         <Promotions onLoginSuccess={handleLoginSuccess} />
//       ) : (
//         <PromotionDeta 
//           data={screenData} 
//           deviceInfo={deviceInfo}
//           onLogout={handleLogout}
//         />
//       )}
//     </div>
//   );
// }

// export default App;




import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Promotions from './Components/Promotions';
import PromotionDeta from './Components/PromotionDeta';
import './App.css';

// Wrapper component to handle navigation
function AppContent() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [screenData, setScreenData] = useState(null);
  const [deviceInfo, setDeviceInfo] = useState({ deviceId: '', password: '' });
  const navigate = useNavigate();

  // Check localStorage on initial load
  useEffect(() => {
    const savedLoginData = localStorage.getItem('promotionLogin');
    if (savedLoginData) {
      try {
        const { screenData, deviceInfo } = JSON.parse(savedLoginData);
        setScreenData(screenData);
        setDeviceInfo(deviceInfo);
        setIsLoggedIn(true);
        // console.log('🔄 Restored login session from localStorage');
        // Navigate to promotion details page
        navigate('/promotiondetails');
      } catch (error) {
        console.error('Failed to restore login session:', error);
        localStorage.removeItem('promotionLogin');
      }
    }
  }, [navigate]);

  // Handle successful login
  const handleLoginSuccess = (data, deviceId, password) => {
    // Save to state
    setScreenData(data);
    setDeviceInfo({ deviceId, password });
    setIsLoggedIn(true);
    
    // Save to localStorage for persistence
    const loginData = {
      screenData: data,
      deviceInfo: { deviceId, password }
    };
    localStorage.setItem('promotionLogin', JSON.stringify(loginData));
    // console.log('💾 Login session saved to localStorage');
    
    // Navigate to promotion details page
    navigate('/promotiondetails');
  };

  // Handle logout/back to login
  const handleLogout = () => {
    // Clear state
    setIsLoggedIn(false);
    setScreenData(null);
    setDeviceInfo({ deviceId: '', password: '' });
    
    // Clear localStorage
    localStorage.removeItem('promotionLogin');
    // console.log('🗑️ Login session cleared from localStorage');
    
    // Navigate back to login
    navigate('/');
  };

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/" 
          element={<Promotions onLoginSuccess={handleLoginSuccess} />} 
        />
        <Route 
          path="/promotiondetails" 
          element={
            isLoggedIn ? (
              <PromotionDeta 
                data={screenData} 
                deviceInfo={deviceInfo}
                onLogout={handleLogout}
              />
            ) : (
              <Navigate to="/" replace />
            )
          } 
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;